import customTx from './_customTx';

export default (oldContentWrapper, newContentWrapper, template, reverse, url) => {

  customTx(
    oldContentWrapper,
    ['.inner-content'],
    newContentWrapper,
    ['.inner-content'],
    template,
    reverse,
    url
  );

};



// WEBPACK FOOTER //
// ./src/main/js/pageTransitions/betweenSurveyPages.js